/**
 * Resolves runtime asset URLs against the deployment's base path.
 *
 * Vite rewrites paths it can see at build time (imports, `<script src>`), but
 * not strings the app fetches at runtime — and the schedule, the reveal
 * catalogue and all 127 photos are fetched at runtime. Hard-coded "/daily.json"
 * works only when the game owns the domain root; embedded under
 * `example.com/game/` it would ask for `example.com/daily.json` and 404.
 *
 * `import.meta.env.BASE_URL` is whatever `base` the build was configured with
 * ("/" by default), so one helper covers both the standalone deployment and
 * the embedded one with no per-environment branching.
 */
export function asset(pathFromRoot: string): string {
  const base = import.meta.env.BASE_URL || "/";
  return `${base.replace(/\/$/, "")}/${pathFromRoot.replace(/^\//, "")}`;
}
